import { Layouts } from "../../constants/Constants";
import LiveChat from "../../assets/img//chat_bubble.png";
import LiveChatHol from "../../assets/img//holChat.png";
import LiveChatDisable from "../../assets/img//chat_bubble_disable.png";
import styles from "../../assets/css/modules/contact-us/online-link.css";

const mol = Layouts.MOL.toLowerCase();
const hol = Layouts.HOL.toLowerCase();


const initialiseLiveAgent = async (layout) => {
  try {
    window.embeddedservice_bootstrap.settings.language = 'en_US'; // For example, enter 'en' or 'en-US'

    window.embeddedservice_bootstrap.settings.restrictSessionOnMessagingChannel = true;

     window.embeddedservice_bootstrap.init(
      window.axa.liveAgentMIAW[layout].orgId,
      window.axa.liveAgentMIAW[layout].esConfigName,
      window.axa.liveAgentMIAW[layout].ESWMSGOnlineServicing,
      {
        scrt2URL: window.axa.liveAgentMIAW[layout].scrt2URL
      }
    );
    var elements = document.getElementsByClassName("embeddedMessagingConversationButton");
    if (elements && elements.length > 0) {
      toggleLiveChat(layout);
    }
    else{
      setTimeout(()=>{
        toggleLiveChat(layout);
      },7000);
    }
  } catch (err) {
    console.error('Error loading Embedded Messaging: ', err);
  }
};

export const toggleLiveChat = (layout) =>{
    var elements = document.getElementsByClassName("embeddedMessagingConversationButton");
    if (elements && elements.length > 0) 
    {
        if(elements[0].style.display !== "none" && document.getElementsByClassName("livechatImage") && document.getElementsByClassName("livechatImage").length>0)
        {
            document.getElementsByClassName("livechatText")[0].style.display = 'none';
            document.getElementsByClassName("livechatLink")[0].style.display = 'inline';
            if (layout.toUpperCase() === Layouts.HOL) {
            document.getElementsByClassName("livechatImage")[0].src=LiveChatHol;
            }
            else{
              document.getElementsByClassName("livechatImage")[0].src=LiveChat;
            }
        }
        else if(document.getElementsByClassName("livechatImage") && document.getElementsByClassName("livechatImage").length>0)
        {
          document.getElementsByClassName("livechatImage")[0].src=LiveChatDisable;    
          document.getElementsByClassName("livechatText")[0].style.display = 'inline';  
          document.getElementsByClassName("livechatLink")[0].style.display = 'none';
        }

        if(elements[0].style.display !== "none" && document.getElementById("contactUsChat")){
        document.getElementById("contactUsChat").getElementsByTagName('a')[0].className = styles.onlineLink;
      }else if(document.getElementById("contactUsChat")){
        document.getElementById("contactUsChat").getElementsByTagName('a')[0].className = styles.disabledchat;
      }
    }
    
  
};

export const initialiseLiveAgentForMOL = () => {
  initialiseLiveAgent(mol);
};

export const initialiseLiveAgentForHOL = () => {
  initialiseLiveAgent(hol);
};
